
import React,{ createRef } from "react";

import { connect } from 'react-redux';

import { Line, Bar } from "react-chartjs-2";
import {dataTrainingLoadProjection} from 'variables/chartsData';
import {optionsTrainingLoad} from 'variables/chartsData';

import 'rc-slider/assets/index.css';

import {runTypePick} from '../helperFunctions/runningProgramFunctions';
// reactstrap components
import {
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  Table,
  Row,
  Col,
  CardFooter,
  Progress,
} from "reactstrap";

import NotificationAlert from "react-notification-alert";

import {runningIndexList} from '../helperFunctions/RunningIndex'
import {runningIndexMedian} from '../helperFunctions/RunningIndex'
import {resampleTssMy,resampleTssMy2} from '../helperFunctions/Resample';
import {fitFatForm, tssList, trainingStatus, trainingScoreCalc,averageProjected} from '../helperFunctions/trainingLoadFunctions'

import CreateProgramModal from '../components/moreComponents/CreateProgramModal'
import WeekProgram from '../components/moreComponents/WeekProgram';
import DeviationHelpModal from '../components/moreComponents/DeviationHelpModal'
import TrainingScoreHelpModal from '../components/moreComponents/TrainingScoreHelpModal'
import TrainingLoadProjectionHelp from '../components/moreComponents/TrainingLoadProjectionHelp'


import {calculateStressScoreTarget,createProjectedDatesFromRunningProgram} from '../helperFunctions/runningProgramFunctions';

import {tableBody} from "../helperFunctions/trainingHistory";
var moment = require('moment')

class RegularTables extends React.Component {
  
  
  
  notify(place,message) {
    if (!message){
      return ""
    }
    var color = message[0];
    if (color === "logout"){
      localStorage.clear()
      window.location.replace("/login")
    }
    var type;
    switch (color) {
      case 'success':
        type = "success";
        break;
      case 'danger':
        type = "danger";
        break;
      case 'warning':
        type = "warning";
      default:
        break;
    }
    var options = {};
    options = {
      place: place,
      message: (
        <div>
          <div style={{height:'70px'}}>
            {message[1]}
          </div>
          
        </div>
      ),
      type: type,
      icon: "now-ui-icons ui-1_bell-53",
      autoDismiss: 10,
    };
    this.refs.notificationAlert.notificationAlert(options);
  }
  
  
  componentDidUpdate(prevProps){
    if(prevProps.message.message !== this.props.message.message && this.props.message.message){
        this.notify("br",this.props.message.message)
    }
  }
  render() {
    if(!Array.isArray(this.props.activities.entries)){
      return(<div></div>)
    }
    const activitiesSorted = this.props.activities.entries?.sort((a, b) =>new Date(a.date) -new Date(b.date));
    //calculate running index
    const [runningIndex,dates]=runningIndexList(activitiesSorted)
    const [runningIndexMedianList,maxMedian,maxIndex] = runningIndexMedian(activitiesSorted)
    const currentIndex = runningIndexMedianList[runningIndexMedianList.length-1]

    /// calculate trainingLoad
    const targetForm = this.props.runningProgram.targetForm
    const [tss,datesTss] = tssList(activitiesSorted)
    const [resampledDates, resampledTss] = resampleTssMy(datesTss,tss)
    const [fitness,fatigue,form] = fitFatForm(resampledDates, resampledTss)
    const currentFitness = fitness[fitness.length-61]
    const currentFatigue = fatigue[fatigue.length-61]
    const currentForm = form[form.length-61]
    
    localStorage.setItem('fitness',currentFitness)
    localStorage.setItem('fatigue',currentFatigue)
    localStorage.setItem('form',currentForm)


    
    
    
    if(!this.props.runningProgram.tss_target){
      if (fitness.length>62){
        return (
          <div>
               <CardTitle tag="h4" style={{marginLeft:"20px",color:'rgb(240,240,240)'}}>Running Program</CardTitle>
                    <p className="category" style={{marginLeft:"20px",color:'rgb(240,240,240)'}}>No running program in progress</p>
              <Row style={{marginTop:'50px'}}>
                <Col xs={12} md={4}>
                
                </Col>
                <Col xs={12} md={4}>
                    <CreateProgramModal />
                </Col>
                <Col xs={12} md={4}>
                
                </Col>
            
              </Row></div>
        )
      }
      else{
        return (
          <div>
               <CardTitle tag="h4" style={{marginLeft:"20px",color:'rgb(240,240,240)'}}>Running Program</CardTitle>
                    <p className="category" style={{marginLeft:"20px",color:'rgb(240,240,240)'}}>No running program in progress</p>
              <Row style={{marginTop:'50px'}}>
                <Col xs={12} md={4}>
                
                </Col>
                <Col xs={12} md={4}>
                    <h2 style={{color:'rgb(240,240,240)'}}>Add more activities first</h2>
                </Col>
                <Col xs={12} md={4}>
                
                </Col>
            
              </Row></div>
        )
      }
      
    }
    /// Calculate running program
    localStorage.setItem('runningIndex',currentIndex)
    localStorage.setItem('fitness',currentFitness)
    localStorage.setItem('fatigue',currentFatigue)
    localStorage.setItem('form',currentForm)
    //console.log(this.props.message.message)
    const program_duration = 4
    var TotalStressScore = 0
    const tss_target = this.props.runningProgram.tss_target
    const tss_until_now = this.props.runningProgram.tss_until_now
    const programType = this.props.runningProgram.runningProgram
    const program_runs_per_week = this.props.runningProgram.program_runs_per_week
    const weekDurations = this.props.runningProgram.weekDates
    var weeks = []
    var tssProjectedList = []
    for (var week=1;week<=program_duration;week++){
        var stressScoreTarget = calculateStressScoreTarget(week,tss_target,targetForm)
        TotalStressScore =TotalStressScore+stressScoreTarget
        var weekType = programType[week-1]
        //console.log(TotalStressScore)
        weeks.push({id:week,program_runs_per_week,weekDurations,weekType,stressScoreTarget})

        // this calculates again all the tss at the parent component to create the projected graph
        const [runType,tss_activity] = runTypePick(weekType,program_runs_per_week)
        
        for(var i=1;i<=program_runs_per_week;i++){
          var tssProjected = tss_activity[i-1]*stressScoreTarget
          tssProjectedList.push(tssProjected)
        }
    }

    // Projected chart 
    const chartColor = "#1ebfe8";
    const gradientFill = 'rgba(255, 255, 200, 0.1)';
    
    const datesProjection = createProjectedDatesFromRunningProgram(weekDurations[0],program_runs_per_week)
    //console.log(weeks)
    //console.log(tssProjectedList)
    var programStartIndex = -1
    for (var i=0;i<datesTss.length;i++){
      
      if(moment(datesTss[i]).isAfter(moment(weekDurations[0]))){
        programStartIndex = i
        console.log(programStartIndex)
        break
      }
    }
    var datesTssSliced = datesTss.slice(0,programStartIndex)
    var tssSliced = tss.slice(0,programStartIndex)
    const [resampledDatesProj, resampledTssProj] = resampleTssMy2(datesTssSliced.concat(datesProjection),tssSliced.concat(tssProjectedList))
    const [fitnessProj,fatigueProj,formProj] = fitFatForm(resampledDatesProj, resampledTssProj)
    const data = dataTrainingLoadProjection(resampledDates.slice(-120,-1),fitnessProj.slice(-120,-1),fatigueProj.slice(-120,-1),formProj.slice(-120,-1),chartColor,gradientFill,[0,100],weekDurations[0])
    const max = Math.max.apply(null, fatigueProj)
    const options = optionsTrainingLoad(max)
    const [colorForm,trainingStat] = trainingStatus(currentForm)

    // projected values 
    const projectedFatigue = fatigueProj[fatigueProj.length-35]
    const projectedFitness = fitnessProj[fitnessProj.length-35]
    var highestValueForm = formProj.slice(-61,-31)
    highestValueForm = Math.min.apply(null, highestValueForm).toFixed(2)
    const averageProj = averageProjected(formProj.slice(-61,-31))

    const [trainingScore,deviat,average] = trainingScoreCalc(form,averageProj*-1)
    console.log("deviat",deviat)
    return (
      <>
        <div className="content" style={{marginTop:"25px",color:"white",fontSize:'12px'}}>
        <NotificationAlert ref="notificationAlert" />
          <Row>
            <Col xs={12}>
              <Card className="card-plain">
                <CardHeader>
                  <CardTitle tag="h4">Running Program</CardTitle>
                  <p className="category">starts: {weekDurations[0]} - ends: {weekDurations[weekDurations.length-1]} </p>
                </CardHeader>
                <CardBody>
                  <Table responsive>
                    <thead className="text-primary">
                      <tr>
                         <th>
                             Type
                         </th>
                         <th>
                             Activity
                         </th>
                         <th>
                             Est Distance
                         </th>
                         <th>
                             StressScore
                         </th>
                      </tr>
                    </thead>
                    {weeks.map((week,key) =>{
                        return(
                            <WeekProgram key={key} week={week} measurementSystem={this.props.auth.measurementSystem}/>
                        )
                    })}
                    
                  </Table>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Row>
            
            <Col xs={12} md={12}>
              <Card className="card-chart" style={{backgroundColor: 'rgb(33,33,33)',color: '#FFFFFF'}}>
                <CardHeader>
                  <h5 className="card-category"></h5>
                  <CardTitle tag="h4"></CardTitle>
                    <Row>
                      <Col xs={12} md={4}>
                        <Card className="card-chart" style={{backgroundColor: 'rgb(25,25,25)',color: '#FFFFFF'}}>
                          <CardHeader>
                          <h5 className="card-category text-warning">Progress</h5>
                          <CardTitle tag="h4">{tss_until_now.toFixed(2)?tss_until_now.toFixed(2):tss_until_now}/<span className='text-warning' style={{fontSize:'10px'}}>{Number(TotalStressScore).toFixed(0)}</span></CardTitle>
                        </CardHeader>
                        <CardFooter>
                          <div className="stats">
                        
                          </div>
                        </CardFooter>
                        </Card>
                  
                      </Col>
                      <Col xs={12} md={4}>
                        <Card className="card-chart" style={{backgroundColor: 'rgb(25,25,25)',color: '#FFFFFF'}}>
                          <CardHeader>
                          <h5 className="card-category text-danger">Perceived Stress</h5>
                          <CardTitle tag="h4">{currentForm ? currentForm.toFixed(0) : 0.00}</CardTitle>
                          
                        </CardHeader>
                        <CardFooter>
                          <div className="stats">
                            <i className="now-ui-icons media-2_sound-wave" style={{color:'rgb(100,255,255)'}}/> <span className={colorForm}>{trainingStat}</span>
                          </div>
                        </CardFooter>
                        </Card>
                  
                      </Col>
                      <Col xs={12} md={4}>
                        <Card className="card-chart" style={{backgroundColor: 'rgb(25,25,25)',color: '#FFFFFF'}}>
                          <CardHeader>
                          <h5 className="card-category text-warning">Training Score</h5>
                          <CardTitle tag="h4">{trainingScore || trainingScore==0.00 ? trainingScore.toFixed(1) : "--"}<span className='text-warning' style={{fontSize:'10px'}}> /10</span></CardTitle>
                        </CardHeader>
                        <CardFooter>
                          <div className="stats">
                              <TrainingScoreHelpModal colorForm />
                          </div>
                        </CardFooter>
                        </Card>
                  
                      </Col>
                    </Row>
                    <Row>
                      <Col xs={12} md={4}>
                        <Card className="card-chart" style={{backgroundColor: 'rgb(25,25,25)',color: '#FFFFFF'}}>
                          <CardHeader>
                          <h5 className="card-category text-warning">Training Deviation</h5>
                          <CardTitle tag="h4">{deviat ? deviat.toFixed(2) : "--"}</CardTitle>
                        </CardHeader>
                        <CardFooter>
                          <div className="stats">
                           <DeviationHelpModal colorForm deviat={deviat}/>
                          </div>
                        </CardFooter>
                        </Card>
                  
                      </Col>
                      <Col xs={12} md={4}>
                        <Card className="card-chart" style={{backgroundColor: 'rgb(25,25,25)',color: '#FFFFFF'}}>
                          <CardHeader>
                          <h5 className="card-category text-danger">Target Perceived Stress</h5>
                          <CardTitle tag="h4">{targetForm ? targetForm*(-1) : 0.00}</CardTitle>
                          
                        </CardHeader>
                        <CardFooter>
                          <div className="stats">
                            <i className="now-ui-icons media-2_sound-wave" style={{color:'rgb(100,255,255)'}}/> <span className={colorForm}>Average Perceived Score : {average.toFixed(2)}</span>
                          </div>
                        </CardFooter>
                        </Card>
                  
                      </Col>
                      
                    </Row>
                </CardHeader>
               
                <CardFooter>
                  <div className="stats">
                    <label>{(tss_until_now*100/TotalStressScore).toFixed(1)} %</label>
                    <Progress color="success" value={tss_until_now*100/TotalStressScore} />
                  </div>
                </CardFooter>
              </Card>
            </Col>
                
            <Col xs={12} md={4}>
              
            </Col>
          </Row>
          <Row>
            
            <Col xs={12} md={12}>
              <Card className="card-chart" style={{backgroundColor: 'rgb(38,38,38)',color: '#FFFFFF'}}>
                <CardHeader>
                  <h5 className="card-category"></h5>
                  <CardTitle tag="h4"></CardTitle>
                    <h3 className='text-warning'>Training Load Projection <TrainingLoadProjectionHelp/></h3>
                    <Row>
                      <Col xs={12} md={12}>
                        <Line
                          data={data}
                          options={options}
                          height='280px'
                        />
                      
                      </Col>
                      
                      
                    </Row>
                    <Row>
                      
                      <Col xs={12} md={4}>
                        <Card className="card-chart" style={{backgroundColor: 'rgb(25,25,25)',color: '#FFFFFF'}}>
                          <CardHeader>
                          <h5 className="card-category text-warning">Fitness</h5>
                          <CardTitle tag="h4">{projectedFitness.toFixed(2)}</CardTitle>
                        </CardHeader>
                        <CardFooter>
                          <div className="stats">
                            <i className="now-ui-icons media-2_sound-wave" style={{color:'rgb(100,255,255)'}}/> {resampledDatesProj[resampledDatesProj.length-35]}
                          </div>
                        </CardFooter>
                        </Card>
                  
                      </Col>
                      <Col xs={12} md={4}>
                        <Card className="card-chart" style={{backgroundColor: 'rgb(25,25,25)',color: '#FFFFFF'}}>
                          <CardHeader>
                          <h5 className="card-category text-danger">Raw stress</h5>
                          <CardTitle tag="h4">{projectedFatigue.toFixed(2)}</CardTitle>
                          
                        </CardHeader>
                        <CardFooter>
                          <div className="stats">
                            <i className="now-ui-icons media-2_sound-wave" style={{color:'rgb(100,255,255)'}}/> {resampledDatesProj[resampledDatesProj.length-35]}
                          </div>
                        </CardFooter>
                        </Card>
                  
                      </Col>
                      <Col xs={12} md={4}>
                        <Card className="card-chart" style={{backgroundColor: 'rgb(25,25,25)',color: '#FFFFFF'}}>
                          <CardHeader>
                          <h5 className="card-category text-danger">Highest perceived stress</h5>
                          <CardTitle tag="h4">{highestValueForm}</CardTitle>
                          
                        </CardHeader>
                        <CardFooter>
                          <div className="stats">
                            <i className="now-ui-icons media-2_sound-wave" style={{color:'rgb(100,255,255)'}}/>Average value: {averageProj.toFixed(2)}
                          </div>
                        </CardFooter>
                        </Card>
                  
                      </Col>
                      
                    </Row>
                </CardHeader>
               
                <CardFooter>
                  <div className="stats">
                    <label>{(tss_until_now*100/TotalStressScore).toFixed(1)} %</label>
                    <Progress color="success" value={tss_until_now*100/TotalStressScore} />
                  </div>
                </CardFooter>
              </Card>
            </Col>
                
            <Col xs={12} md={4}>
              
            </Col>
          </Row>
          <Row>
              <Col xs={12} md={4}>
              
              </Col>
              <Col xs={12} md={4}>
                  <CreateProgramModal />
              </Col>
              <Col xs={12} md={4}>
              
              </Col>
          
          </Row>
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) =>{
  return {activities:state.activities,runningProgram:state.runningProgram,message:state.message,auth:state.auth}
}


export default connect(mapStateToProps)(RegularTables);
